import React, { Component } from 'react'
import styles from './_searchForm.css'
import Svg from 'components/util/Svg'
import { injectIntl, intlShape, defineMessages } from 'react-intl'

const MESSAGES = defineMessages({
  'placeholder': {
    id: 'site.nav.search.placeholder',
    defaultMessage: 'Search',
  },
})

export class SearchForm extends Component {

  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    active: false,
  };

  handleShow = () => {
    this.setState({ active: true }, () => {
      if (this._input) { this._input.focus() }
    })
  }

  handleHide = () => {
    this.setState({ active: false })
  }

  render () {
    const { active } = this.state
    const formClass = active ? styles.form : styles.formDisabled

    return (
      <div className={styles.container}>
        <span className={styles.button} onClick={this.handleShow}>
          <Svg name='search' className={styles.icon} />
        </span>
        <form method='get' action='/site/search/' className={formClass}>
          <input
            type='text'
            ref={(input) => { this._input = input }}
            placeholder={this.props.intl.formatMessage(MESSAGES.placeholder)}
            className={styles.input}
            onBlur={this.handleHide}
            onFocus={this.handleShow}
          />
        </form>
      </div>
    )
  }

}

export default injectIntl(SearchForm)



// WEBPACK FOOTER //
// ./src/components/layout/header/SearchForm.jsx